<template>
  <div>
    <span v-if="user" class="d-none d-xl-inline">
      <font-awesome-layers class="fa-1x me-2">
        <font-awesome-icon :icon="['fas', 'user']" />
      </font-awesome-layers>
      <strong>{{ user.name }}</strong><br>&lt;{{ user.email }}&gt;
    </span>
    <span v-else class="d-none d-xl-inline">
      <font-awesome-layers class="fa-1x me-2">
        <font-awesome-icon :icon="['fas', 'user']" />
      </font-awesome-layers>
      <strong>{{ $t('global.anonymousUser') }}</strong>
    </span>
  </div>
</template>

<script setup lang="ts">
import User from '@/models/frontend/User';

defineProps({
  user: { type: Object as () => User | null, required: true },
});
</script>
